import { Option } from 'components/_inputs/_types/Option';
import type { SubjectId, SubjectPk, SupportedSubjects } from 'types/Subject';

import { SubjectDto, Subject, SubjectDetailsDto, SubjectDetails } from './subjects.types';

type ParseSubjectsListForUI = (input: SubjectDto[]) => Subject[];
type ParseSubjectsListForDropdown = (input: Subject[], addSelectAllOption: boolean) => Option[];
type ParseSubjectForUI = (input: SubjectDetailsDto) => SubjectDetails;

const toSubjectId = (id: number): SubjectId => String(id) as SubjectId;
const toSubjectPk = (id: number): SubjectPk => id as SubjectPk;
const toSubjectCode = (code: string): SupportedSubjects => code as SupportedSubjects;

const parseSubjectsListForUI: ParseSubjectsListForUI = raw =>
  (raw ?? []).map(subject => ({
    id: toSubjectId(subject.id),
    pk: toSubjectPk(subject.id),
    name: subject.name,
    subjectCode: toSubjectCode(subject.subject_code),
    active: Boolean(subject.active),
  }));

const parseSubjectForUI: ParseSubjectForUI = raw => ({
  id: raw.id,
  name: raw.name,
  subjectCode: toSubjectCode(raw.subject_code),
  active: raw.active,
  sections: (raw.sections ?? []).map(section => ({
    id: section.id,
    name: section.name,
    index: section.index,
    free: Boolean(section.free),
    subsections: section.subsections ?? [],
  })),
});

const parseSubjectsListForDropdown: ParseSubjectsListForDropdown = (raw, addSelectAllOption) => {
  if (!raw) return [];

  const base = raw.map(({ pk, name }) => ({ value: pk, label: name }));

  if (!addSelectAllOption) return base;
  return [{ value: '', label: 'Wszystkie' }, ...base];
};

const parseSectionDataToDropdown = (data?: { id: string | number; name: string }[]): Option[] => {
  if (!data) return [];

  return [{ value: '', label: 'Wszystkie' }, ...data.map(({ id, name }) => ({ value: id, label: name }))];
};

export { parseSubjectsListForUI, parseSubjectForUI, parseSubjectsListForDropdown, parseSectionDataToDropdown };
